'use strict';

import type { GlobPlans } from '../../Entities/Glob/GlobPlans';
import { EntityCollection } from '../EntityCollection';

export class GlobPlansCollection extends EntityCollection<GlobPlans> {}
